"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchesSelector = matchesSelector;
exports.onStyleSheetAdded = onStyleSheetAdded;
exports.getStyleSheets = getStyleSheets;
exports.getMatchedCssRules = getMatchedCssRules;
exports.formatStyle = formatStyle;
exports.getOrCreateInlineStyleSheetId = getOrCreateInlineStyleSheetId;
exports.getInlineStyleSheetId = getInlineStyleSheetId;
exports.getInlineStyleNodeId = getInlineStyleNodeId;
exports.getStyleSheetText = getStyleSheetText;
var each_1 = __importDefault(require("licia/each"));
var Emitter_1 = __importDefault(require("licia/Emitter"));
var strHash_1 = __importDefault(require("licia/strHash"));
var toStr_1 = __importDefault(require("licia/toStr"));
var trim_1 = __importDefault(require("licia/trim"));
var cssPriority_1 = __importDefault(require("licia/cssPriority"));
var map_1 = __importDefault(require("licia/map"));
var util_1 = require("./util");
var elProto = Element.prototype;
var matchesSel = function () { return false; };
if (elProto.webkitMatchesSelector) {
    matchesSel = function (el, selText) { return el.webkitMatchesSelector(selText); };
}
else if (elProto.mozMatchesSelector) {
    matchesSel = function (el, selText) { return el.mozMatchesSelector(selText); };
}
else if (elProto.msMatchesSelector) {
    matchesSel = function (el, selText) { return el.msMatchesSelector(selText); };
}
function matchesSelector(el, selText) {
    return matchesSel(el, selText);
}
var emitter = new Emitter_1.default();
function onStyleSheetAdded(fn) {
    emitter.on('styleSheetAdded', fn);
}
function getStyleSheets() {
    (0, each_1.default)(document.styleSheets, function (styleSheet) {
        if (!styleSheet.styleSheetId) {
            styleSheet.styleSheetId = getStyleSheetId(styleSheet.href);
        }
    });
    return document.styleSheets;
}
function getMatchedCssRules(node) {
    var unsorted = [];
    (0, each_1.default)(document.styleSheets, function (styleSheet) {
        var styleSheetId = styleSheet.styleSheetId;
        if (!styleSheetId) {
            styleSheetId = getStyleSheetId(styleSheet.href);
            styleSheet.styleSheetId = styleSheetId;
            emitter.emit('styleSheetAdded', styleSheet);
        }
        try {
            if (!styleSheet.cssRules)
                return;
        }
        catch (e) {
            return;
        }
        (0, each_1.default)(styleSheet.cssRules, function (cssRule) {
            var matchesEl = false;
            try {
                matchesEl = matchesSelector(node, cssRule.selectorText);
            }
            catch (e) {
            }
            if (!matchesEl)
                return;
            unsorted.push({
                selectorText: cssRule.selectorText,
                style: cssRule.style,
                styleSheetId: styleSheetId,
            });
        });
    });
    var sorted = [];
    var priorities = (0, map_1.default)(unsorted, function (_a, i) {
        var selectorText = _a.selectorText;
        return (0, cssPriority_1.default)(selectorText, { position: i });
    });
    (0, each_1.default)(priorities.sort(cssPriority_1.default.compare), function (property) {
        sorted.push(unsorted[property[5]]);
    });
    return sorted;
}
function formatStyle(style) {
    var ret = {};
    for (var i = 0, len = style.length; i < len; i++) {
        var name_1 = style[i];
        ret[name_1] = style[name_1] || (0, trim_1.default)(style.getPropertyValue(name_1));
    }
    return ret;
}
var inlineStyleSheetIds = new Map();
var inlineStyleNodeIds = new Map();
function getOrCreateInlineStyleSheetId(nodeId) {
    var styleSheetId = inlineStyleSheetIds.get(nodeId);
    if (styleSheetId)
        return styleSheetId;
    styleSheetId = getStyleSheetId();
    inlineStyleSheetIds.set(nodeId, styleSheetId);
    inlineStyleNodeIds.set(styleSheetId, nodeId);
    return styleSheetId;
}
function getInlineStyleSheetId(nodeId) {
    return inlineStyleSheetIds.get(nodeId);
}
function getInlineStyleNodeId(styleSheetId) {
    return inlineStyleNodeIds.get(styleSheetId);
}
var styleSheetTexts = new Map();
function getStyleSheetText(styleSheetId_1) {
    return __awaiter(this, arguments, void 0, function (styleSheetId, proxy) {
        var i, len, styleSheet, text;
        if (proxy === void 0) { proxy = ''; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (styleSheetTexts.get(styleSheetId)) {
                        return [2, styleSheetTexts.get(styleSheetId)];
                    }
                    i = 0, len = document.styleSheets.length;
                    _a.label = 1;
                case 1:
                    if (!(i < len)) return [3, 4];
                    styleSheet = document.styleSheets[i];
                    if (!(styleSheet.styleSheetId === styleSheetId)) return [3, 3];
                    return [4, (0, util_1.getTextContent)(styleSheet.href, proxy)];
                case 2:
                    text = _a.sent();
                    styleSheetTexts.set(styleSheetId, text);
                    return [3, 4];
                case 3:
                    i++;
                    return [3, 1];
                case 4: return [2, styleSheetTexts.get(styleSheetId) || ''];
            }
        });
    });
}
function getStyleSheetId(sourceUrl) {
    if (sourceUrl === void 0) { sourceUrl = ''; }
    if (sourceUrl) {
        return (0, toStr_1.default)((0, strHash_1.default)(sourceUrl));
    }
    return (0, util_1.createId)();
}
